export var buildEnv = {
    buildMode: 'release',
    datacenter: 'us',
    sdkVersion: '1.25.4',
};
//# sourceMappingURL=buildEnv.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@datadog/browser-rum/esm/boot/buildEnv.js
// module id = ErSz
// module chunks = 1